let baseUrl = (window.location.host == '127.0.0.1:8080' || window.location.host == 'http://192.168.7.16:8082/' ? '/api' : '');
export default baseUrl;